/**
 * `unassignedSymbol` は、未割り当てを表すシンボルです。\
 * セレクトボックスなどの初期値として使用されます。\
 * `null` とは異なり、`unassignedSymbol` はユーザーがまだ値を割り当てていないことを明示的に示すために使用されます。\
 * `null` はユーザーが値を割り当てた結果、値がないことを示すために使用されます。\
 * このため、`null` と区別して扱うことができます。
 */
export const unassignedSymbol = Symbol('unassigned')
export type Unassigned = typeof unassignedSymbol

/**
 * 検査対象が未割り当てかどうかを判定します。\
 * `null` は 未割り当て(`Unassigned`)ではないので注意してください。
 *
 * @template T - 検査対象の型。
 * @param value - 検査対象。
 * @returns 未割り当て(`Unassigned`)の場合は true 、そうでない場合は false。
 */
export function isUnassigned<T>(
  value: T | Unassigned | null,
): value is Unassigned {
  return value === unassignedSymbol
}

/**
 * 検査対象が割り当て済みかどうかを判定します。\
 * `null` は 未割り当て(`Unassigned`) ではなく割り当て済みとして扱われるので注意してください。
 *
 * @template T - 検査対象の型。
 * @param value - 検査対象。
 * @returns 未割り当て(`Unassigned`)の場合は false 、そうでない場合は true。
 */
export function isAssigned<T>(value: T | Unassigned | null): value is T | null {
  return value !== unassignedSymbol
}
